import React, {  } from 'react'
import { geometry2geoJson, amersfoort2graden } from '../utils/location'
import { MapContainer, TileLayer, LayersControl, GeoJSON } from 'react-leaflet'
import MarkerClusterGroup from 'react-leaflet-markercluster';
import * as L from "leaflet";
import "leaflet/dist/leaflet.css"
import { useStore } from "../Store"
import {coloredMarker} from '../utils/marker'
import VisitService from '../services/VisitService';
import RDGridLayer from './RDGridLayer'

require('react-leaflet-markercluster/dist/styles.min.css')

const FeatureMap = ({ data, popup }) => {
    const position = amersfoort2graden(155000, 463000)
    const { plots } = useStore()
    const myPlots = plots.filter(p => p.location).map(p => geometry2geoJson(p.location.geometry)).filter(feature => feature.type !== 'Point');

    const pointToLayer = (feature, latlng) => {
        var color= feature.properties.color || process.env.REACT_APP_PRIMARYCOLOR
        var marker
        if (feature.properties.exact) {
            marker= L.marker(latlng, { 
                icon: coloredMarker({L, color})
            })
        }
        else {
            marker= L.circleMarker(latlng, {
                radius: 8,
                fillColor: color,
                color: "#A9A9A9",
                weight: 1,
                opacity: 1,
                fillOpacity: 0.8
            })
        }
        marker.bindPopup('<p>loading data...</p>')
        marker.on("click", (e) => showPopup(e, feature))
        return marker
    }

    const showPopup = (e, feature) => {
        e.target.closePopup()
        e.target.unbindPopup()
        if (feature.properties.details) {
            VisitService.getFeatureDetails(feature.properties.id)
            .then(result => {
                e.target.bindPopup(popup(result.data), { closeButton: false }).openPopup()
            })
        } else {
            e.target.bindPopup(popup({
                observation: {
                    description: feature.properties.description.split(' / ')[0],
                    extraInfo: { onderwerp: feature.properties.description.split(' / ')[2] || '' },
                    uploads: []
                },
                visit: {
                    description: feature.properties.description.split(' / ')[1] || '',
                    uploads: []
                }
            }), { closeButton: false }).openPopup()
        }
    }

    const onEachFeature = (feature, layer) => {
        if (!L.Browser.mobile) {
            layer.bindTooltip(feature.properties.description)
        }
    }

    return (
        <>
            <MapContainer center={position} zoom={9} scrollWheelZoom={true} style={{ height: '100%', zIndex: 0 }} >
                <LayersControl position="topright">
                    <LayersControl.BaseLayer checked name="OpenStreetMap">
                        <TileLayer
                            attribution='&copy; <a href="https://www..org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Luchtfoto">
                        <TileLayer
                            attribution='&copy; <a href="https://www.nationaalgeoregister.nl/">Nationaal Georegister</a>'
                            url="https://service.pdok.nl/hwh/luchtfotorgb/wmts/v1_0/Actueel_ortho25/EPSG:3857/{z}/{x}/{y}.jpeg"
                        />
                    </LayersControl.BaseLayer>
                    <LayersControl.Overlay name="1x1 km RDS Grid">
                        <RDGridLayer />
                    </LayersControl.Overlay>

                </LayersControl>
                <MarkerClusterGroup
                    showCoverageOnHover={true}
                    chunkedLoading={true}
                    singleMarkerMode={false}
                    zoomToBoundsOnClick={true}
                    maxClusterRadius={80}
                    spiderfyOnMaxZoom={true}
                >
                    <GeoJSON key={new Date().getTime()} data={data} pointToLayer={pointToLayer} onEachFeature={onEachFeature} />
                </MarkerClusterGroup>
                <GeoJSON key='myPlots' data={myPlots} />
            </MapContainer>
        </>
    )
}

export default FeatureMap
